module.exports = __webpack_public_path__ + "static/media/seal-black.77495beb.png";